module.exports = __webpack_public_path__ + "img/pizzarouge_off.31a77e88.gif";